import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Cards from "../card/card";
import "../movieList/movieList.css";

const MovieFilter = () => {
    const [movieList, setMovieList] = useState([]);
    const [genres, setGenres] = useState([]);
    const [selectedGenres, setSelectedGenres] = useState([]);
    const [selectedYear, setSelectedYear] = useState("");
    const [years, setYears] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [isGenreDropdownOpen, setIsGenreDropdownOpen] = useState(false);
    const { genre, release_year } = useParams();

    useEffect(() => {
        fetchGenres();
        fetchYears();
    }, []);

    useEffect(() => {
        if (genre || release_year) {
            setSelectedGenres(genre ? [genre] : []);
            setSelectedYear(release_year || "");
            setPage(1);
            setMovieList([]);
            getData(genre ? [genre] : [], release_year || "", 1);
        }
    }, [genre, release_year]);

    const fetchGenres = () => {
        fetch(`https://api.themoviedb.org/3/genre/movie/list?api_key=4e44d9029b1270a757cddc766a1bcb63&language=en-US`)
            .then(res => res.json())
            .then(data => setGenres(data.genres || []))
            .catch(error => console.error("Error fetching genres:", error));
    };

    const fetchYears = () => {
        const currentYear = new Date().getFullYear();
        const startYear = 1920;
        const yearsArray = Array.from({ length: currentYear - startYear + 1 }, (_, index) => currentYear - index);
        setYears(yearsArray);
    };

    const getData = (selectedGenres, selectedYear, page) => {
        let url = `https://api.themoviedb.org/3/discover/movie?api_key=4e44d9029b1270a757cddc766a1bcb63&language=en-US&page=${page}`;
        if (selectedGenres.length > 0) url += `&with_genres=${selectedGenres.join(',')}`;
        if (selectedYear) url += `&primary_release_year=${selectedYear}`;

        fetch(url)
            .then(res => res.json())
            .then(data => {
                setMovieList(prevMovies => [...prevMovies, ...data.results]);
                setTotalPages(data.total_pages);
            })
            .catch(error => console.error("Error fetching movie data:", error));
    };

    const handleGenreChange = (genreId) => {
        const updatedSelectedGenres = selectedGenres.includes(genreId)
            ? selectedGenres.filter(id => id !== genreId)
            : [...selectedGenres, genreId];
        setSelectedGenres(updatedSelectedGenres);
        setPage(1);
        setMovieList([]);
        getData(updatedSelectedGenres, selectedYear, 1);

        const numSelectedGenres = updatedSelectedGenres.length;
        let label = "";
        switch (numSelectedGenres) {
            case 0:
                label = "Select Genre";
                break;
            case 1:
                label = "One Genre Selected";
                break;
            case 2:
                label = "Two Genres Selected";
                break;
            default:
                label = `${numSelectedGenres} Genres Selected`;
                break;
        }
        document.getElementById("genre-label").textContent = label;
    };

    const handleYearChange = (event) => {
        const selectedYear = event.target.value;
        setSelectedYear(selectedYear);
        setPage(1);
        setMovieList([]);
        getData(selectedGenres, selectedYear, 1);
    };

    const handleLoadMore = () => {
        const nextPage = page + 1;
        if (nextPage <= totalPages) {
            setPage(nextPage);
            getData(selectedGenres, selectedYear, nextPage);
        }
    };

    const toggleGenreDropdown = () => {
        setIsGenreDropdownOpen(!isGenreDropdownOpen);
    };

    return (
        <div className="movie__list">
            <div className="filters text-center mb-4" style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "40px" }}>
                <div className="custom-dropdown" style={{  width: "200px", zIndex: 2000 }}>
                    <div
                        className="dropdown-toggle"
                        onClick={toggleGenreDropdown}
                        style={{
                            border: "1px solid #ced4da",
                            borderRadius: "8px",
                            padding: "8px",
                            cursor: "pointer",
                            backgroundColor: "#fff",
                            textAlign: "left",
                            height:"fit-content"
                        }}
                    >
                        <span id="genre-label">
                            {selectedGenres.length > 0 ? `${selectedGenres.length} Genres Selected` : "Select Genre"}
                        </span>
                    </div>
                    {isGenreDropdownOpen && (
                        <div
                            className="dropdown-options"
                            style={{
           top: "100%",
                                left: "0",
                                width: "100%",
                                border: "1px solid #ced4da",
                                borderRadius: "8px",
                                backgroundColor: "#fff",
                                zIndex: 1050,
                                maxHeight: "200px",
                                overflowY: "auto",
                                height:"fit-content"
                            }}
                        >
                            {genres.map((genre) => (
                                <div key={genre.id} className="dropdown-item" style={{ padding: "8px", cursor: "pointer" }}>
                                    <input
                                        type="checkbox"
                                        id={`genre-${genre.id}`}
                                        value={genre.id}
                                        checked={selectedGenres.includes(genre.id)}
                                        onChange={() => handleGenreChange(genre.id)}
                                    />
                                    <label htmlFor={`genre-${genre.id}`} style={{ marginLeft: "8px" }}>{genre.name}</label>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                <select className="form-select" value={selectedYear} onChange={handleYearChange} style={{  width: "200px", borderRadius: "8px", padding: "8px", zIndex: 2000 }}>
                    <option value="">Select Release Year</option>
                    {years.map((year, index) => (
                        <option key={index} value={year}>
                            {year}
                        </option>
                    ))}
                </select>
            </div>
            <div className="list__cards">
                {movieList.map((movie, index) => (
                    <Cards key={movie.id} movie={movie} index={index} style={{ zIndex: 1000 }} />
                ))}
            </div>
            {page < totalPages && (
                <div className="text-center">
                    <button className="btn btn-primary" style={{ backgroundColor: "white", color: "black" }} onClick={handleLoadMore}>Load More</button>
                </div>
            )}
        </div>
    );
}

export default MovieFilter;
